
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dinners/new",
      function () {
        return require("private-next-pages/dinners/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dinners/new"])
      });
    }
  